import { render, staticRenderFns } from "./Tgbs.vue?vue&type=template&id=057aa4aa&"
import script from "./Tgbs.vue?vue&type=script&lang=js&"
export * from "./Tgbs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports